import React, { useContext } from 'react';
import { Metadata } from '@thd-olt-component-react/metadata';
import { Typography } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { PrivacyMetadata } from './PrivacyMetadata';
import './styles/supplyChainPrivacyPolicy.scss';
import { imageBaseUrl } from '../../constants';

const metadata = {
  title: 'Supply Chain Privacy Policy - The Home Depot',
  description: 'The Home Depot values and respects your privacy. Please use this page to request the '
    + 'personal information we collect about you, request that we delete your personal information, '
    + 'and opt out of having your personal information sold.',
  canonical: 'https://www.homedepot.com/privacy/driver-handheld-app-privacy-statement'
};

export const SupplyChainPrivacyPolicy = () => {

  const { channel } = useContext(ExperienceContext);

  return (
    <div style={{ backgroundColor: '#f5f5f5' }} className="supply-policy">
      <Metadata>
        <PrivacyMetadata
          title={metadata.title}
          description={metadata.description}
          canonical={metadata.canonical}
        />
      </Metadata>
      <div className="container">
        <div className="cdg-content--header">
          <Typography variant="h1" weight="bold" className="cdg-header">
            <img
              height="40"
              width="40"
              alt="Privacy ToolBox"
              src={imageBaseUrl + '/PrivacyToolbox_logo_CLR.svg'}
              style={{ marginRight: '10px', display: 'inline-block', verticalAlign: 'middle' }}
            />
            Driver Handheld Application Policy
          </Typography>
        </div>
        <div className="cdg-content--body">
          <div id="supplyPolicyContent" className="white margin-20 supply-policy__content sui-grid sui-gap-4">
            <div className="sui-grid sui-gap-4">
              <div className="content-title">
                <h1 data-testid="supplyChainPageTitle">The Home Depot Driver Handheld Application Privacy Statement</h1>
                <br />
                <h5>Your privacy is important to us. This statement explains the information
                  The Home Depot&apos;s (&quot;Company&quot;) Driver Handheld App (&quot;App&quot;)
                  collects and how we use it. This privacy statement only applies to this App.
                  If you are interacting with us in other ways not related to the App, users can find the
                  applicable full statements below:
                </h5>
                <ul>
                  <li>
                    <h5>
                      <strong>Non-associates (non-THD employee App users)</strong> - please see our
                      Privacy and Security Statement and our Notice at
                      Collection for California residents, which can be found{' '}
                      <a href="https://www.homedepot.com/privacy/privacy-and-security-statement">here</a>.
                    </h5>
                  </li>
                  <li>
                    <h5>
                      <strong>Associates</strong> - please see our Associate Privacy Statement
                      which can be
                      found <a href="https://careers.homedepot.com/associate-privacy-statement/">here</a>.
                    </h5>
                  </li>
                </ul>
                <br />
                <h5>
                  We have compiled information about the number of California privacy rights requests
                  we received in the previous calendar year and how we responded to them. Please{' '}
                  <a href="https://www.homedepot.com/privacy/California-Privacy-Rights-and-Report">view
                    the California Privacy Rights & Report page for the report
                  </a>.
                </h5>
                <br />
                <h5><u>INFORMATION WE MAY COLLECT WHEN YOU USE THE APP</u></h5>
                <br />
                <div className="table-container">
                  <table className="supply-chain-table">
                    <tbody>
                      <tr>
                        <th scope="col"><u>Category of Personal Information</u></th>
                        <th scope="col"><u>Purpose for Collection</u></th>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td><i>Identifiers</i>, such as phone number,
                          username, online identifier, device
                          identifier, IP address, and other
                          similar identifiers.
                        </td>
                        <td>
                          Complete and facilitate deliveries to our facilities and
                          business partner facilities or fulfilling orders to our
                          customers and related work tasks.<br />
                          To manage our relationship.<br />
                          To operate and improve our business.<br />
                          To support workforce analytics.<br />
                          Communicating with you.<br />
                          Complying with laws and regulations and cooperating
                          with law enforcement as we deem reasonably
                          necessary to comply with laws, support investigations,
                          and protect the rights and property of you, us, and
                          others.<br />
                          Monitoring use of technology in compliance with our policies and
                          practices.<br />
                          Fraud prevention, security, and asset protection.
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>
                          <i>App activity</i>, including but not
                          limited to incoming and outgoing
                          electronic communications,
                          selection and function history,
                          search history, interactions with
                          applications, login credentials,
                          electronic records and files, IP
                          addresses and other information
                          associated with delivery activities,
                          and logs of application access and use.
                        </td>
                        <td>
                          Complete and facilitate deliveries to our facilities and
                          business partner facilities or fulfilling orders to our
                          customers and related work tasks.<br />
                          To manage our relationship.<br />
                          To operate and improve our business.<br />
                          To support workforce analytics.<br />
                          Communicating with you.<br />
                          Complying with laws and regulations and cooperating
                          with law enforcement as we deem reasonably
                          necessary to comply with laws, support investigations,
                          and protect the rights and property of you, us, and
                          others.<br />
                          Monitoring use of technology in compliance with our policies and
                          practices.<br />
                          Fraud prevention, security, and asset protection.
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>
                          <i>Commercial Information</i>, such as
                          descriptions of products delivered,
                          delivery history, delivery times, or
                          other similar information captured
                          by the App.
                        </td>
                        <td>
                          Complete and facilitate deliveries to our facilities and
                          business partner facilities or fulfilling orders to our
                          customers and related work tasks.<br />
                          To support workforce analytics.<br />
                          Customer care. Communicating with you.<br />
                          Communicating with customers.<br />
                          Improving our products and services, including
                          improving app functions and delivery efficiency and
                          effectiveness.<br />
                          Complying with laws and regulations and cooperating
                          with law enforcement as we deem reasonably
                          necessary to comply with laws, support investigations,
                          and protect the rights and property of you, us, and
                          others.<br />
                          Fraud prevention, security, and asset protection.
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>
                          <i>Location Information</i>, such as
                          location based on IP address or
                          mobile device location information,
                          which may include mobile device
                          precise geo-location.
                        </td>
                        <td>
                          Complete and facilitate deliveries to our facilities and
                          business partner facilities or fulfilling orders to our
                          customers and related work tasks.<br />
                          Providing precise delivery directions.<br />
                          To support workforce analytics.<br />
                          Customer care.<br />
                          Complying with laws and regulations and cooperating
                          with law enforcement as we deem reasonably
                          necessary to comply with laws, support investigations,
                          and protect the rights and property of you, us, and
                          others.<br />
                          Monitoring use of technology in compliance with our policies and
                          practices.<br />
                          Fraud prevention, security, and asset protection.
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>
                          <i>Information that may be considered
                            sensitive personal information
                          </i>, such as account login credentials,
                          and precise geolocation.
                        </td>
                        <td>
                          See relevant disclosures above regarding Identifiers
                          (for account login credentials), and Location
                          Information (for precise geolocation).
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br />
                <h5><strong>Information Disclosures</strong></h5>
                <br />
                <h5>We may share your information for business purposes and as legally required
                  or permitted by law. Examples of circumstances in which we share
                  information include the following:
                </h5>
                <ul>
                  <li>
                    <h5>Service providers who perform services on our behalf, such as
                      suppliers, vendors, providers of analytics services, data storage
                      providers, communication services, fraud prevention services, and
                      other service providers as may be deemed necessary by The Home
                      Depot in order to conduct its business.
                    </h5>
                  </li>
                  <li>
                    <h5>
                      Customers and others for communication purposes.
                    </h5>
                  </li>
                  <li>
                    <h5>
                      Authorized business partners.
                    </h5>
                  </li>
                  <li>
                    <h5>
                      Any successor to all or part of our business.
                    </h5>
                  </li>
                  <li>
                    <h5>
                      Law enforcement, public and government authorities, and other
                      entities as we deem reasonably necessary to comply with laws,
                      support investigations, and protect the rights and property of you, us,
                      and others.
                    </h5>
                  </li>
                  <li>
                    <h5>
                      Our affiliates and subsidiaries.
                    </h5>
                  </li>
                </ul>
                <br />
                <h5><strong>Retention</strong></h5>
                <br />
                <h5>
                  We retain the personal information we collect regarding users of the App for as
                  long as reasonably necessary to assess driver performance and compliance, manage
                  ongoing delivery driver relationships, and achieve the purposes disclosed above,
                  unless a shorter retention period is required by law. We may retain personal information
                  after employment or business partner relationships end or after employment decisions
                  are made. The length of retention may vary depending upon factors such as:
                </h5>
                <ul>
                  <li>
                    <h5>The existence of an ongoing relationship between you and us;</h5>
                  </li>
                  <li>
                    <h5>Recordkeeping or legal compliance requirements;</h5>
                  </li>
                  <li>
                    <h5>The need to resolve inquiries or complaints; and</h5>
                  </li>
                  <li>
                    <h5>Protecting the rights or safety of you, us, or others.</h5>
                  </li>
                </ul>
                <br />
                <h5><strong>Data Deletion</strong></h5>
                <br />
                <h5>
                  Associates can exercise their privacy rights, including making a request to delete
                  data, by clicking{' '}
                  <a
                    href="https://wd5.myworkday.com/homedepot/d/inst/13102!CK5mGhIKBggDEMenAhIICgYI1A0QhwE~*4SOeeMdoljs~/cacheable-task/23748$49.htmld"
                  >here
                  </a>
                  {' '}or calling us at:{' '}
                  <a href="tel:+18666984347">1-866 myTHDHR (1.866.698.4347)</a>
                  {' '}and selecting option 4 and then selecting Privacy Questions
                </h5>
                <br />
                <h5>
                  If you are a non-associate, to exercise your privacy rights, including making a request
                  to delete data, please visit:{' '}
                  <a href="http://m.homedepot.com/c/exercise_my_privacy_rights">Do Not Sell My Personal Information</a>
                  {' '}or{' '}
                  <a href="https://www.homedepot.com/privacy/Exercise-My-Privacy-Rights">
                    https://www.homedepot.com/privacy/Exercise-My-Privacy-Rights
                  </a>.
                  {' '}Current or former associates may exercise their privacy rights{' '}
                  <a
                    href="https://wd5.myworkday.com/homedepot/d/inst/13102!CK5mGhIKBggDEMenAhIICgYI1A0QhwE~*4SOeeMdoljs~/cacheable-task/23748$49.htmld"
                  >here
                  </a>.
                </h5>
                <br />
                <h5>
                  There may be circumstances where we may not completely fulfill your deletion request,
                  as permitted under the CCPA or other applicable laws. For example, if you submit a
                  request to delete your personal information, we may need to retain certain personal
                  information to complete a transaction, detect fraud, or comply with our legal obligations.
                </h5>
                <br />
                <h5><strong>Access to Device Functions</strong></h5>
                <br />
                <h5>
                  <strong>Location information</strong> - Our App uses the location information you
                  directly provide to us, such as your address or zip code, as well as data obtained
                  from your device regarding the device&apos;s location and motion activity to provide
                  precise driving directions, monitor speed and stop times, determine delivery time
                  estimates, and measure delivery driver performance and compliance with our policies
                  and procedures. You can control how we use your device&apos;s location information
                  in the settings menu of your device, but if you deny access, you may not be able to
                  use the App for deliveries and other App related work tasks.
                </h5>
                <br />
                <h5>
                  <strong>Push Notifications</strong> - We use the information we collect to facilitate
                  an effective and efficient delivery and customer experience, which may include sending
                  you push notifications. We obtain your consent before sending push notifications
                  to you via this App. You can control your receipt of push notifications in the settings
                  menu of your device.
                </h5>
                <br />
                <h5>
                  <strong>Camera and Photo Storage</strong> - We request access to your device camera
                  and photo storage to allow you to provide proof of delivery evidence and scan THD QR
                  codes throughout the delivery process. We obtain your consent before accessing your
                  camera and photo storage prior to allowing access via this app. Access to your camera
                  and photo storage is initiated by the user of the App. You can control App access to
                  your camera and photo storage in the settings menu of your device, but if you deny
                  access you may not be able to provide proof of delivery evidence in the App for
                  deliveries, scan THD QR codes from the App, and complete other similar work tasks.
                </h5>
                <br />
                <h5>
                  <strong>Microphone</strong> - We request access to your device microphone to allow
                  you to communicate with customers or others related to deliveries. We obtain your
                  consent before accessing your microphone prior to allowing access via this app.
                  Access to your microphone is initiated by the user of the App. If you do not allow
                  App access to your microphone in the settings menu of your device, you may not be
                  able to talk to customers or others in the App for deliveries and other similar work tasks.
                </h5>
                <br />
                <h5>
                  <strong>Motion and Fitness</strong> - We request access to your device motion and
                  fitness sensors to allow detection of movement to efficiently manage location updates
                  to save battery life. We obtain your consent before accessing your motion and fitness
                  sensors prior to allowing access via this app. Access to your motion and fitness sensors
                  is initiated by the user of the App. You can control App access to your motion and
                  fitness sensors in the settings menu of your device, but if you deny access the App
                  may consume more of your battery power, reducing battery life when using location services.
                </h5>
                <br />
                <h5><strong>Nearby Devices (Bluetooth)</strong> - We request access to your device’s Nearby
                  Device feature to find, connect to, and determine the relative position of
                  nearby Bluetooth devices to enable connecting a Bluetooth headset for VoIP
                  calls and hands-free audio communication. This access is
                  used to route call audio locally on your device. We obtain your consent
                  before accessing your Nearby Device feature prior to allowing
                  access via this App. Access to your device’s Nearby Device
                  feature is initiated by the user of the App. You can control App
                  access to your device’s Nearby Device feature in the settings menu of
                  your device, but if you deny access the App may not be able to connect to
                  work-related devices offering Bluetooth connectivity.
                </h5>
                <br />
                <h5><strong>Make and Manage Calls</strong> - We request access to your device’s Make and
                  Manage Calls feature to (i) enable receiving native lock-screen notifications
                  for inbound dispatch calls; (ii) placing outbound VoIP calls to customers;
                  and (iii) to manage in-call audio routing. This access is used on your device
                  to enable calling features. Access to the Make and Manage Calls feature is
                  initiated by the user of the App. You can control App access to the Make and
                  Manage Calls feature in the settings menu of your device, but if you deny
                  access the App may not be able to receive notifications for inbound calls
                  when your screen is locked or make outbound VoIP calls to customers with
                  your device using the App.
                </h5>
                <br />
                <h3><u>HOW TO CONTACT US</u></h3>
                <br />
                <h5>
                  If you have questions about our privacy practices you can call us at
                  1-800-394-1326, or you can write to us at:
                </h5>
                <br />
                <h5>The Home Depot</h5>
                <br />
                <h5>Attention: Privacy Official Customer Care</h5>
                <br />
                <h5>2455 Paces Ferry Road</h5>
                <br />
                <h5>Atlanta, GA 30339-4024</h5>
                <br />
                <h5><i>Date of first posting: May 29th, 2025</i></h5>
                <h5><i>Last revision date: September 23th, 2026</i></h5>
                <br />
                <h5>
                  From time to time we may change our privacy policies. We will notify you of any
                  material changes to our Driver Handheld App privacy statement by posting an updated
                  copy in the App and potentially via other channels. Please check the App periodically
                  for updates.
                </h5>
                <br />
                <h5>For further details about our privacy practices, please visit:</h5>
                <h5>Non-associates:{' '}
                  <a href="https://www.homedepot.com/privacy/privacy-and-security-statement">
                    https://www.homedepot.com/privacy/privacy-and-security-statement
                  </a>
                </h5>
                <h5>Associates:{' '}
                  <a href="https://careers.homedepot.com/associate-privacy-statement">
                    https://careers.homedepot.com/associate-privacy-statement
                  </a>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
